import Navbar from '../components/navbar/Navbar';

const Header = () => {
  return (
    <div>
      <Navbar />
    </div>
  );
};

export default Header;
